import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { business } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-brand-stone">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-center lg:justify-between">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-white/10">
              <Logo className="h-6 w-6" dark />
            </span>
            <span className="font-display text-lg font-semibold">
              Max&rsquo;s Concrete Cutting <span className="text-brand-teal">Perth</span>
            </span>
          </div>

          {/* Contact inline */}
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 text-sm">
            <a href={business.phoneHref} className="flex items-center gap-2 hover:text-brand-teal transition-colors">
              <Phone className="h-4 w-4 text-brand-teal" /> {business.phone}
            </a>
            <a href={`mailto:${business.email}`} className="flex items-center gap-2 hover:text-brand-teal transition-colors">
              <Mail className="h-4 w-4 text-brand-teal" /> {business.email}
            </a>
            <span className="flex items-center gap-2 text-brand-stone/70">
              <MapPin className="h-4 w-4 text-brand-teal" /> {business.area}
            </span>
          </div>

          <Link
            to="/quote"
            className="inline-flex shrink-0 items-center justify-center rounded-full bg-brand-teal px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-white hover:text-brand-ink"
          >
            Get a Quote
          </Link>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 pt-6">
          <p className="text-xs text-brand-stone/40">
            © {new Date().getFullYear()} {business.name}. All rights reserved.
          </p>
          <p className="text-xs text-brand-stone/40">
            Made by{" "}
            <a
              href="https://www.layerly.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-brand-teal hover:text-white transition-colors"
            >
              Layerly
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
